import(/* webpackMode: "eager" */ "/vercel/path0/app/drag/page.tsx");
